type HostMessage =
    | { type: 'editor:ready' }
    | { type: 'addUserImages:start'; total: number }
    | { type: 'addUserImages:progress'; done: number; total: number }
    | { type: 'addUserImages:error'; url: string; message: string }
    | {
          type: 'addUserImages:done';
          succeeded: number;
          failed: number;
          errors: Array<{ url: string; message: string }>;
      };

export const postToHost = (message: HostMessage) => {
    try {
        const bridge = (window as any).ReactNativeWebView;
        if (bridge && typeof bridge.postMessage === 'function') {
            bridge.postMessage(JSON.stringify(message));
        }
    } catch {
        // Swallow — host messaging failures must never break uploads.
    }
};